import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component'; // <--- Import FormsModule
import { Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { UrlReferenceService } from '../../shared/services/url-reference.service';
import { AuthService } from '../../shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-otp-screen',
  templateUrl: './otp-screen.component.html',
  styleUrls: ['./otp-screen.component.scss'],
  imports: [FormsModule, HeaderComponent, FooterComponent, TranslateModule],
})
export class OtpScreenComponent implements OnInit {
  otp: string = '';
  email: string = '';
  phoneNumber: string = '';
  constructor(
    private http: HttpClient,
    private router: Router,
    private translate: TranslateService,
    private urlRef: UrlReferenceService,
    private authService: AuthService,
    private toastr: ToastrService
  ) {
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit(): void {
    this.email = this.authService.getUserData().email || '';
    this.phoneNumber = this.authService.getUserData().phoneNumber || '';
  }

  onOtpInput(event: any): void {
    console.log('OTP input changed:', this.otp);
  }

  confirmOtp(): void {
    console.log('Confirming OTP:', this.otp);
    console.log(
      'Payload for OTP verification:',
      this.authService.getUserData()
    );

    const payload = {
      email: this.authService.getUserData().email,
      isSignup: this.authService.getUserData().isSignup,
      otpSentVia: this.authService.getUserData().phoneNumber ? 'SMS' : 'EMAIL',
      otp: this.otp,
    };
    console.log('Payload for OTP verification:', payload);
    this.http.post(this.urlRef.getValidateOtpUrl(), payload).subscribe({
      next: (res: any) => {
        console.log('OTP verified successfully:', res);
        let fromGetQuote = localStorage.getItem('from-get-quote');
        let fromSignUp = localStorage.getItem('from-signup');
        if (res.otpValid === true) {
          // if (res.data.otpValid === 'true') {
          if (fromGetQuote) {
            // Ensure company data is properly persisted before navigation
            console.log(
              'OTP verified - navigating to onboarding with from-get-quote flag'
            );
            localStorage.setItem('from-get-quote', 'true');
            this.router.navigate(['/onboarding']);
          } else if (fromSignUp) {
            this.router.navigate(['/company-details']);
          }
          // } else {
          //   this.toastr.error('Invalid OTP. Please try again.');
          // }
        } else {
          this.toastr.error('Invalid OTP. Please try again.');
        }
      },
      error: (err) => {
        this.toastr.error('Something went wrong, Please try again');
      },
    });
  }

  changePhoneNumber(): void {
    let fromGetQuote = localStorage.getItem('from-get-quote');
    let fromSignUp = localStorage.getItem('from-signup');
    localStorage.removeItem('from-get-quote');
    localStorage.removeItem('from-signup');
    if (fromGetQuote === 'true') {
      this.router.navigate(['/company-details']);
    } else if (fromSignUp === 'true') {
      this.router.navigate(['/']);
    }
    console.log('Changing phone number');
  }

  resendOtp(): void {
    console.log('Resending OTP to', this.email);

    const payload = {
      phoneNumber: this.authService.getUserData().phoneNumber
        ? this.authService.getUserData().phoneNumber
        : '',
      email: this.authService.getUserData().phoneNumber
        ? ''
        : this.authService.getUserData().email,
      otpSentVia: this.authService.getUserData().phoneNumber ? 'SMS' : 'EMAIL',
    };

    this.http.post(this.urlRef.getRegenerateOtpUrl(), payload).subscribe({
      next: (res: any) => {
        console.log('OTP resent successfully:', res);
        alert('OTP has been resent to your phone number.');
      },
      error: (err) => {
        console.error('Failed to resend OTP:', err);
        alert('Failed to resend OTP. Please try again later.');
      },
    });
  }
}
